import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1a6866e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "text-muted text-xxs" }

import DegenLayerLogo from '@/components/degenLayer/DegenLayerLogo.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { POWERED_BY_DEGEN_LAYER } from '@/constants/POWERED_BY_DEGEN_LAYER';


export default /*#__PURE__*/_defineComponent({
  __name: 'DegenLayerLabel',
  props: {
    asPanel: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n();
const isShowLabel = computed(() => POWERED_BY_DEGEN_LAYER);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isShowLabel))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["degen-layer-label gap-4 flex-center", __props.asPanel ? 'degen-layer-panel' : ''])
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('crosschainBy')), 1),
          _createVNode(DegenLayerLogo)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})